import { Outlet, Link } from "react-router-dom";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from 'react-toastify';

const Layout = () => {
  // const navigate = useNavigate();
  // useEffect(() => {
  //   const loggedInUser = localStorage.getItem("user-token");
  //   if (loggedInUser) {
  //       navigate("/servant");
  //   }
  // }, []);

  return (
    <>
      {/* <ToastContainer /> */}
      <nav className="navbar navbar-expand-lg navbar-light" style={{backgroundColor: '#e3f2fd'}}>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto">
            
            <li className="nav-item">
              <Link to="/" className="nav-link">Home</Link>
            </li>
            {/* <li className="nav-item">
              <Link to="/blogs" className="nav-link">Blogs</Link>
            </li>
            <li className="nav-item">
              <Link to="/contact" className="nav-link">Contact</Link>
            </li> */}
            <li className="nav-item">
              <Link to="/register" className="nav-link">Register</Link>
            </li>
            <li className="nav-item">
              <Link to="/login" className="nav-link">Login</Link>
            </li>

          </ul>
        </div>
      </nav>

      <Outlet />
    </>
  )
};

export default Layout;